import {
  CreateUpdateRecommendedPublisherDto,
  DefaultApi,
  GetRecommendationsDto,
  GetGroupedRecommendationsDto,
  GetClientExtendedDto,
  GetLastEditorDto,
} from '../autogenerated/pokApiClient';

export interface RecommendedPublisherContextInterface {
  getSelectedPublishers(
    profileId: string,
    companyId?: string,
    purchaserId?: string,
  ): Promise<GetRecommendationsDto[]>;
  getGroupedRecommendations: () => Promise<GetGroupedRecommendationsDto[]>;
  getAvailablePublishers: (
    profileId: string,
  ) => Promise<GetClientExtendedDto[]>;
  saveRecommendations: (
    dto: CreateUpdateRecommendedPublisherDto,
  ) => Promise<void>;
  getLastEditor: (
    profileId: string,
    companyId?: string,
    purchaserId?: string,
  ) => Promise<GetLastEditorDto>;
}

export const RecommendedPublisherContext = (
  api: DefaultApi,
): RecommendedPublisherContextInterface => {
  return {
    getGroupedRecommendations: async () =>
      api.recommendedPublisherControllerGetGroupedRecommendations(),
    getSelectedPublishers: async (
      profileId: string,
      companyId?: string,
      purchaserId?: string,
    ) =>
      api.recommendedPublisherControllerGetSelectedPublishers(
        profileId,
        companyId,
        purchaserId,
      ),
    getAvailablePublishers: async (profileId: string) =>
      api.recommendedPublisherControllerGetAvailablePublishers(profileId),
    saveRecommendations: async (dto: CreateUpdateRecommendedPublisherDto) =>
      api.recommendedPublisherControllerSaveRecommendations(dto),
    getLastEditor: async (
      profileId: string,
      companyId?: string,
      purchaserId?: string,
    ) =>
      api.recommendedPublisherControllerGetLastEditor(
        profileId,
        companyId,
        purchaserId,
      ),
  };
};
